<img #pointElement [style]="getStyle()" class="point drag"
     [src]="iconUrl | fileUrl : 'FILES' | offline : {offline: isOffline, project: projectId} | safe"
     [matTooltip]="(point.title | plain) | decodeHtmlEntities:[]" [matTooltipPosition]="'above'"
     [matTooltipDisabled]="isDrag" (click)="onClick()" (mousedown)="isMoved = false">

